module.exports = __webpack_public_path__ + "static/media/file-doc-2.f4ab1fb6.svg";